import { render, staticRenderFns } from "./competeGroupsList.vue?vue&type=template&id=ce19925e&"
import script from "./competeGroupsList.vue?vue&type=script&lang=js&"
export * from "./competeGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports